// extracted by mini-css-extract-plugin
module.exports = {"OrderHead":"styles_OrderHead__u_ghO","cta":"styles_cta___9SPU"};